<section class="container py-5 mt-5 mb-lg-4 mb-xl-5">
  <div class="row pt-xl-3 mt-n1 mt-sm-0">
    <div class="col-lg-9 offset-lg-3 pt-lg-3">
      <h1 class="pb-2 pb-sm-3">Evenimente publice</h1>
    </div>
  </div>
  <div class="row pb-2 pb-sm-4">
    <!-- Sidebar -->
    <aside class="col-lg-3">
      <div class="offcanvas-lg offcanvas-start d-none d-lg-block">
        <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
      </div>
    </aside>
    <div class="col-lg-9">
      <!-- Active filters + Sorting-->
      <div class="d-sm-flex align-items-start justify-content-between mb-4">
        <div class="d-flex align-items-center flex-shrink-0 mb-2 order-sm-1"><span
            class="text-muted text-nowrap fs-sm">Ordoneaza dupa:</span>
          <select [(ngModel)]="sort" (ngModelChange)="onSortChange()" class="form-select form-select-flush py-0">
            <option value="newest">Cele mai noi</option>
            <option value="oldest">Cele mai vechi</option>
            <option value="deadline">Termen limita</option>
            <option value="low-high">Contributie crescator</option>
            <option value="high-low">Contributie descrescator</option>
          </select>
        </div>
        <div class="me-3 order-sm-0">
          <div class="nav d-md-none">
            <a (click)="activeFiltersCollapsed = !activeFiltersCollapsed" [class.collapsed]="activeFiltersCollapsed"
              [attr.aria-expanded]="!activeFiltersCollapsed" class="nav-link dropdown-toggle fs-sm p-0 mb-2"
              role="button">Filtre
              active</a>
          </div>
          <div [(ngbCollapse)]="activeFiltersCollapsed" class="collapse d-md-block">
            <div class="pt-2 pt-md-0">
              <a *ngIf="keywordFilter" (click)="onRemoveFilterClick({keyword: ''})"
                class="d-inline-block border rounded-pill fs-xs fw-medium text-body text-decoration-none py-1 px-2 me-2 mb-2"
                role="button">
                <span class="d-inline-flex align-items-center text-nowrap px-1">{{keywordFilter}}<i
                    class="ai-circle-x fs-base ms-1"></i></span></a>
              <a *ngIf="activeFilter" (click)="onRemoveFilterClick({active: false})"
                class="d-inline-block border rounded-pill fs-xs fw-medium text-body text-decoration-none py-1 px-2 me-2 mb-2"
                role="button"><span class="d-inline-flex align-items-center text-nowrap px-1">Active<i
                    class="ai-circle-x fs-base ms-1"></i></span></a>
              <a *ngIf="completedFilter" (click)="onRemoveFilterClick({completed: false})"
                class="d-inline-block border rounded-pill fs-xs fw-medium text-body text-decoration-none py-1 px-2 me-2 mb-2"
                role="button"><span class="d-inline-flex align-items-center text-nowrap px-1">Completed<i
                    class="ai-circle-x fs-base ms-1"></i></span></a>
              <a *ngFor="let eventType of eventTypesFilter" (click)="onRemoveEventTypeFilterClick(eventType.id)"
                class="d-inline-block border rounded-pill fs-xs fw-medium text-body text-decoration-none py-1 px-2 me-2 mb-2"
                role="button"><span class="d-inline-flex align-items-center text-nowrap px-1">{{eventType.name}}<i
                    class="ai-circle-x fs-base ms-1"></i></span></a>
              <button *ngIf="hasFilters" (click)="onRemoveAllFiltersClick()"
                class="btn btn-sm btn-secondary rounded-pill fw-medium py-1 px-2" type="button"><span
                  class="px-1">Sterge toate filtrele</span></button>
            </div>
          </div>
        </div>
      </div>
      <gs-event-list [events]="events" [itemsPerPage]="9" [canShowContributeButton]="true"
        [canDisplayNoResultPage]="false"></gs-event-list>

      <!-- No filter results template -->
      <div *ngIf="events?.length === 0" class="card border-0 bg-secondary text-center">
        <svg-icon src="assets/images/illustrations/no-search-results.svg" svgClass="w-50 h-50 mt-3"></svg-icon>
        <div class="card-body">
          <h4 class="card-title">Nicio inregistrare</h4>
          <p class="card-text">Ne pare rau, nu a fost gasit niciun rezultat care sa corespunda cautarii.</p>
        </div>
      </div>

      <!-- Loading template -->
      <div *ngIf="!events" class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4">
        <div *ngFor="let item of [].constructor(9)" class="col">
          <div class="card" aria-hidden="true">
            <div class="position-relative placeholder-glow">
              <div class="card-img-top placeholder ratio ratio-16x9"></div>
              <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
            </div>
            <div class="card-body">
              <h5 class="card-title placeholder-glow">
                <span class="placeholder col-6"></span>
              </h5>
              <p class="card-text placeholder-glow">
                <span class="placeholder placeholder-sm col-7 me-2"></span>
                <span class="placeholder placeholder-sm col-4"></span>
                <span class="placeholder placeholder-sm col-4 me-2"></span>
                <span class="placeholder placeholder-sm col-6"></span>
                <span class="placeholder placeholder-sm col-8"></span>
              </p>
              <a href="#" tabindex="-1" class="btn btn-primary disabled placeholder col-6 placeholder-glow"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Sidebar toggle button-->
<button (click)="onOpenFilterMenuClick(filtersTemplate)"
  class="d-lg-none btn btn-sm fs-sm btn-primary shadow w-100 rounded-0 fixed-bottom"><i
    class="ai-filter me-2"></i>Filtre</button>

<ng-template #filtersTemplate let-offcanvas>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">Filtre</h5>
    <button (click)="offcanvas?.dismiss()" class="btn-close" type="button"></button>
  </div>
  <div class="offcanvas-body pt-2 pt-lg-0 pe-lg-4">
    <form [formGroup]="form" novalidate autocomplete="off">
      <!-- Search -->
      <h3 class="h5">Cautare</h3>
      <div class="pb-2 mb-4">
        <div class="me-2 mb-2">
          <div class="position-relative mb-lg-2"><i
              class="ai-search fs-lg position-absolute top-50 start-0 translate-middle-y ms-3"></i>
            <input formControlName="keyword" class="form-control form-control-sm ps-5" type="search"
              placeholder="Cauta dupa titlu...">
          </div>
        </div>
      </div>
      <!-- State -->
      <h3 class="h5">Stare</h3>
      <div class="pb-2 mb-4">
        <div class="form-check form-switch mb-3">
          <input formControlName="active" class="form-check-input" type="checkbox" id="active">
          <label class="form-check-label" for="active">Active</label>
        </div>
        <div class="form-check form-switch mb-3">
          <input formControlName="completed" class="form-check-input" type="checkbox" id="completed">
          <label class="form-check-label" for="completed">Complete</label>
        </div>
      </div>
      <!-- Categories -->
      <h3 class="h5">Categorii</h3>
      <div formArrayName="eventTypes" class="pb-2">
        <!-- <div class="form-check">
                <input [formControlName]="0" class="form-check-input" type="checkbox" value="all" id="all">
                <label class="form-check-label d-flex align-items-center" for="all"><span class="text-nav fw-medium">Toate categoriile</span></label>
              </div> -->
        <div *ngFor="let eventType of eventTypes; index as i" class="form-check">
          <input [formControlName]="i" class="form-check-input" type="checkbox" [id]="eventType.id">
          <label class="form-check-label d-flex align-items-center" [for]="eventType.id"><span
              class="text-nav fw-medium">{{eventType.name}}</span></label>
        </div>
      </div>
    </form>
  </div>
  <!-- Footer -->
  <div class="offcanvas-header d-flex border-top d-lg-none">
    <button (click)="offcanvas?.dismiss()" class="btn btn-dark w-100 me-2" type="button">
      Aplica
    </button>
  </div>
</ng-template>
